import { Link } from 'react-router-dom';
import { relatedArticles } from '../../../mocks/product';

const ArticleLinks = () => {
  const color = '#ff2d78';

  return (
    <section className="py-16 px-4 md:px-8 lg:px-12" style={{ background: '#050508' }}>
      <div className="max-w-7xl mx-auto">

        {/* Header */}
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="font-orbitron font-black text-2xl md:text-3xl text-white mb-1">
              СТАТЬИ О ТОВАРЕ
            </h2>
            <p className="font-mono text-xs text-white/30">Экспертные материалы с упоминанием NeuroPlex Ultra</p>
          </div>
          <Link
            to="/blog"
            className="hidden md:flex items-center gap-2 font-mono text-xs cursor-pointer transition-all duration-300 whitespace-nowrap hover:gap-3"
            style={{ color }}
          >
            Все статьи <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {relatedArticles.map((article) => (
            <Link
              key={article.id}
              to={`/blog/${article.slug}`}
              className="rounded-2xl overflow-hidden group cursor-pointer relative block transition-all duration-300"
              style={{ border: '1px solid rgba(255,255,255,0.06)', background: 'rgba(255,255,255,0.015)' }}
              onMouseEnter={e => {
                (e.currentTarget as HTMLElement).style.borderColor = `${color}35`;
                (e.currentTarget as HTMLElement).style.transform = 'translateY(-3px)';
              }}
              onMouseLeave={e => {
                (e.currentTarget as HTMLElement).style.borderColor = 'rgba(255,255,255,0.06)';
                (e.currentTarget as HTMLElement).style.transform = 'translateY(0)';
              }}
            >
              {/* Image */}
              <div className="relative h-44 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  style={{ filter: 'brightness(0.7)' }}
                />
                <div className="absolute inset-0" style={{ background: 'linear-gradient(to top, rgba(5,5,8,0.8) 0%, transparent 60%)' }} />

                {/* Category badge */}
                <div
                  className="absolute top-3 left-3 px-2.5 py-1 rounded-full font-mono text-[10px] tracking-wider"
                  style={{ background: `${color}20`, color, border: `1px solid ${color}40`, backdropFilter: 'blur(10px)' }}
                >
                  {article.category}
                </div>

                {/* Source */}
                <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between">
                  <span className="font-mono text-xs text-white/60">{article.source}</span>
                  <span className="font-mono text-xs text-white/40">{article.readTime} чтения</span>
                </div>
              </div>

              {/* Content */}
              <div className="p-5">
                <div className="font-mono text-[10px] text-white/30 mb-2">{article.date}</div>
                <h3 className="font-orbitron font-bold text-sm text-white mb-3 leading-snug group-hover:text-white/80 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="font-mono text-xs text-white/40 leading-relaxed line-clamp-3 mb-4">
                  {article.excerpt}
                </p>

                <div
                  className="flex items-center gap-2 font-mono text-xs transition-all duration-300 group-hover:gap-3"
                  style={{ color }}
                >
                  <span>Читать статью</span>
                  <i className="ri-arrow-right-line" />
                </div>
              </div>

              {/* Hover top accent */}
              <div
                className="absolute top-0 left-0 right-0 h-0.5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                style={{ background: `linear-gradient(90deg, transparent, ${color}, transparent)` }}
              />
            </Link>
          ))}
        </div>

        <div className="mt-6 text-center md:hidden">
          <Link
            to="/blog"
            className="inline-flex items-center gap-2 font-mono text-xs cursor-pointer transition-all duration-300 whitespace-nowrap"
            style={{ color }}
          >
            Все статьи <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ArticleLinks;
